import { render, staticRenderFns } from "./QuotePartsControlOrdered.vue?vue&type=template&id=8a7f4aa4&scoped=true"
import script from "./QuotePartsControlOrdered.vue?vue&type=script&lang=js"
export * from "./QuotePartsControlOrdered.vue?vue&type=script&lang=js"
import style0 from "./QuotePartsControlOrdered.vue?vue&type=style&index=0&id=8a7f4aa4&prod&lang=scss&scoped=true"
import style1 from "./QuotePartsControlOrdered.vue?vue&type=style&index=1&id=8a7f4aa4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a7f4aa4",
  null
  
)

export default component.exports